import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import Grid from '@material-ui/core/Grid'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ArrowBackIosSharpIcon from '@material-ui/icons/ArrowBackIosSharp';
import LocalShippingSharpIcon from '@material-ui/icons/LocalShippingSharp';
import HomeIcon from '@material-ui/icons/Home'
import Hidden from '@material-ui/core/Hidden'
import { SignOut } from 'aws-amplify-react';
import { green, red, yellow } from '@material-ui/core/colors';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import PhotoIcon from '@material-ui/icons/Photo';
import PostAddIcon from '@material-ui/icons/PostAdd';

const styles = theme => ({
	categoryHeader: {
		textAlign: "center",
		paddingTop: 16,
		paddingBottom: 16,
	},
	categoryHeaderPrimary: {
		color: theme.palette.common.white,
	},
	item: {
		paddingTop: 4,
		paddingBottom: 4,
		color: 'rgba(255, 255, 255, 0.7)',
	},
	itemCategory: {
		backgroundColor: '#232f3e',
		boxShadow: '0 -1px 0 #404854 inset',
		paddingTop: 16,
		paddingBottom: 16,
	},
	firebase: {
		fontSize: 24,
		fontFamily: theme.typography.fontFamily,
		color: theme.palette.common.white,
	},
	itemActionable: {
		'&:hover': {
			backgroundColor: 'rgba(255, 255, 255, 0.08)',
		},
	},
	itemActiveItem: {
		color: '#4fc3f7',
	},
	itemPrimary: {
		color: 'inherit',
		fontSize: theme.typography.fontSize,
		'&$textDense': {
			fontSize: theme.typography.fontSize,
		},
	},
	textDense: {},
	divider: {
		marginTop: theme.spacing.unit * 2,
	},
})

function prettyText(text) {
	return (text.length > 16 ? text.slice(0,13) + "..." : text)
}

function compare(a, b){
	const aRev = new Date(a.UTCdate)
	const bRev = new Date(b.UTCdate)

    if (aRev > bRev) return -1;
    if (bRev > aRev) return 1;

    return 0;
}

function generateCategories(dicts, location) {
	const {inspectionDict, vehicleDict} = dicts

	var vCategory = {
		id: 'Vehicles',
		children:[]
	}
	
	for (var vId in vehicleDict) {
		const vehicle = vehicleDict[vId]

		vCategory.children.push({
			id: vId,
			name: prettyText(vehicle.vehicleData.unitNumber),
			data: vehicle.lastDate,
			icon: (
				vehicle.lastStatus === 'Needs Repair' ?
				<ErrorIcon style={{ color: red[500], marginRight:"5"}}/>:
				(
					vehicle.lastStatus === 'Monitor' ?
					<ReportProblemIcon style={{ color: yellow[500], marginRight:"5"}}/>:
					<CheckCircleIcon style={{ color: green[500], marginRight:"5"}}/> 
				)
			),
			page: `vehicle?${vId}`
		})
	}
	
	var vehicle = vehicleDict[Object.keys(vehicleDict)[0]]
	if (location.search && location.search.slice(1) in vehicleDict) {
		vehicle = vehicleDict[location.search.slice(1)]
	} else if (location.search && location.search.slice(1) in inspectionDict) {
		const vId = inspectionDict[location.search.slice(1)].vId
		vehicle = vehicleDict[vId]
	}

	var iCategory = {
		id: 'Inspections',
		children:[]
	}
	
	if (vehicle) {
		const sortedInspections = vehicle.inspections.sort(compare)

		for (var iId = 0; iId < sortedInspections.length; iId++) {
			const inspection = sortedInspections[iId]

			iCategory.children.push({
				id: inspection.id,
				name: inspection.name + (inspection.metadata.type === "workorder" ? "W":""),
				data: inspection.odometer,
				icon: (
					inspection.status === 'Needs Repair' ?
					<ErrorIcon style={{ color: red[500], marginRight:"5"}}/>:
					(
						inspection.status === 'Monitor' ?
						<ReportProblemIcon style={{ color: yellow[500], marginRight:"5"}}/>:
						<CheckCircleIcon style={{ color: green[500], marginRight:"5"}}/> 
					)
				),
				page: `inspection?${inspection.id}`
			})
		}
	}

	return {vCategory, iCategory}
}

function Navigator({ classes, onClose, location, dicts, ...rest }) {
	const {vCategory, iCategory} = generateCategories(dicts, location)
	
	return (
		<Drawer variant="permanent" onClose={onClose} {...rest}>
			<List disablePadding>
				<ListItem className={classNames(classes.firebase, classes.item, classes.itemCategory)}>
					<Grid container spacing={8} direction="row">
						<Hidden smUp>
							<Grid  item><ArrowBackIosSharpIcon style={{marginTop:"10"}} onClick={() => onClose()}/></Grid>
						</Hidden>
						<Grid item><SignOut/></Grid>
					</Grid>
				</ListItem>
				<Link style={{ textDecoration: 'none', color: 'inherit' }} to="/">
					<ListItem className={classNames(classes.item, classes.itemCategory)}>
						<ListItemIcon>
							<HomeIcon />
						</ListItemIcon>
						<ListItemText
							classes={{
								primary: classes.itemPrimary,
							}}
						>
							Vehicle Summary
						</ListItemText>
					</ListItem>
				</Link>
				<Link style={{ textDecoration: 'none', color: 'inherit' }} to="/newvehicle">
					<ListItem className={classNames(classes.item, classes.itemCategory)}>
						<ListItemIcon>
							<LocalShippingSharpIcon />
						</ListItemIcon>
						<ListItemText
							classes={{
								primary: classes.itemPrimary,
							}}
						>
							Add New Vehicle
						</ListItemText>
					</ListItem>
				</Link>
				<Link style={{ textDecoration: 'none', color: 'inherit' }} to="/newinspection">
					<ListItem className={classNames(classes.item, classes.itemCategory)}>
						<ListItemIcon>
							<PostAddIcon />
						</ListItemIcon>
						<ListItemText
							classes={{
								primary: classes.itemPrimary,
							}}
						>
							Custom Inspections
						</ListItemText>
					</ListItem>
				</Link>
				<Link style={{ textDecoration: 'none', color: 'inherit' }} to="/qrcodes">
					<ListItem className={classNames(classes.item, classes.itemCategory)}>
						<ListItemIcon>
							<PhotoIcon />
						</ListItemIcon>
						<ListItemText
							classes={{
								primary: classes.itemPrimary,
							}}
						>
							Generate QR-Codes
						</ListItemText>
					</ListItem>
				</Link>
				<Grid container spacing={0}>
				<Grid item xs={6}> 
					{[vCategory].map(({ id, children }) => (
						<React.Fragment key={id}>
							<ListItem className={classes.categoryHeader}>
								<ListItemText
									classes={{
										primary: classes.categoryHeaderPrimary,
									}}
								>
									{id}
								</ListItemText>
							</ListItem>
							{children.map(({ id: childId, name: childName, data: childData, icon, page = null }) => {
								let vId = null
								if (location.search) {
									if (location.search.slice(1) in dicts.vehicleDict) {
										vId = location.search.slice(1)
									} else if (location.search.slice(1) in dicts.inspectionDict) {
										vId = dicts.inspectionDict[location.search.slice(1)].vId
									}
								}

								return page ? (
									<Link
										key={childId}
										style={{ textDecoration: 'none', color: 'inherit' }}
										to={`/${page}`}
									>
										<ListItem
											button
											dense
											className={classNames(
												classes.item,
												classes.itemActionable,
												(vId ? vId === childId : false) && classes.itemActiveItem,
											)}
										
										>
											{icon}
											<ListItemText
												classes={{
													primary: classes.itemPrimary,
													textDense: classes.textDense,
												}}
											>
												{childName}
												<br/>
												{childData}
											</ListItemText>
											
										</ListItem>
									</Link>
								) : (
									<div />
								)
							})}
						</React.Fragment>
					))}
				</Grid>
				<Grid item xs={6}> 
					{[iCategory].map(({ id, children }) => (
						<React.Fragment key={id}>
							<ListItem className={classes.categoryHeader}>
								<ListItemText
									classes={{
										primary: classes.categoryHeaderPrimary,
									}}
								>
									{id}
								</ListItemText>
							</ListItem>
							{children.map(({ id: childId, name: childName, data: childData, icon, page = null }) => {
								const iId = (location.search && location.search.slice(1) in dicts.inspectionDict) ? 
									location.search.slice(1) : 
									null
								;

								return page ? (
									
									<Link
										key={childId}
										style={{ textDecoration: 'none', color: 'inherit' }}
										to={`/${page}`}
									>
										<ListItem
											button
											dense
											className={classNames(
												classes.item,
												classes.itemActionable,
												(iId ? iId === childId : false) && classes.itemActiveItem
											)}
										>
											{icon}
											<ListItemText
												classes={{
													primary: classes.itemPrimary,
													textDense: classes.textDense,
												}}
											>
												{childName}
												<br/>
												{childData}
											</ListItemText>
										</ListItem>
									</Link>
								) : (
									<div />
								)
							})}
						</React.Fragment>
					))}
				</Grid>
				</Grid>
				
			</List>
		</Drawer>
	)
}

Navigator.propTypes = {
	classes: PropTypes.object.isRequired,
	location: PropTypes.object,
}

export default withStyles(styles)(Navigator)
